import React from 'react';
import axios from 'axios';
import { Grid, Button, TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from "@material-ui/core/";
// const FormItem = Form.Item;
import TextField from "@material-ui/core/TextField";
// import Link from '@material-ui/core/Link';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import EditRoundedIcon from "@material-ui/icons/EditRounded";
import Moment from 'react-moment';
class TradeUser extends React.Component<any, any>{
  constructor(props) {
    super(props)
    this.state = {
      values: [{ index: Math.random(), question: '', answer: '' }],
      question: '',
      answer: '',
      editId: null,
      edit: false,
    }
    // this.state = { values: [{question: '',response: ''}] };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
  }


  componentDidUpdate() {
    setTimeout(() => this.setState({ errorMessage: '' }), 40000);
    setTimeout(() => this.setState({ sucessMessage: '' }), 40000);
  }
  uploadDocument = (e) => {
    console.log(e);
  }



  handlequestionChange = event => { this.setState({ question: event.target.value }) }
  handleanswerNameChange = event => {
    this.setState({ answer: event })
  }

  handleSubmit = event => {
    event.preventDefault();
    event.target.reset()
    console.log(this.props.rowId);
    let rId = this.props.rowId;
    const posts = rId;
    console.log(posts);
    // Based on several assumptions: single obj returned, posts is never empty
    axios.post('https://gatewayapi-uat.invest19.com/api/faqs',
      {
        ipoId: this.props.rowId,
        faqList: [
          {
            question: this.state.question,
            answer: this.state.answer,
          }
        ]
      }
    ).then(res => {
      this.getData();
      this.setState({ question: '' })
      this.setState({ answer: '' })
    })
      .catch(err => {
        this.setState({ errorMessage: err.message });
      })
  }

  handleUpdate = event => {
    event.preventDefault();
    event.target.reset()
    console.log(this.props.rowId);
    let rId = this.props.rowId;
    const posts = rId;
    console.log(posts);
    // Based on several assumptions: single obj returned, posts is never empty
    axios.post('https://gatewayapi-uat.invest19.com/api/faqs/',
      {
        ipoId: this.props.rowId,
        faqList: [
          {
            id: this.state.editId,
            question: this.state.question,
            answer: this.state.answer,
          }
        ]
      }
    ).then(res => {
      this.getData();
      this.setState({ question: '' })
      this.setState({ answer: '' })
      this.setState({ edit: false })
    })
    // this.setState({ posts });

    // .catch(err => {
    //   this.setState({ errorMessage: err.message });
    // })
  }

  componentDidMount() {
    this.getData()
  };

  getData() {
    let rId = this.props.rowId;
    
    axios.get(`https://gatewayapi-uat.invest19.com/performance/get/all/transaction/details/between/dates/for/user?page_from=0&page_to=100&date_from=&date_to=&clientBowId=${rId}`)
      .then(res => {
        const faq = res.data;
        this.setState({ faq });
        if (!res.data.length) {
            this.setState({noData: true}) 
          } else {
            this.setState({
              data:res.data, noData: false
            })
          }
      })
  };

  delete(id) {
    fetch(`https://gatewayapi-uat.invest19.com/api/faqs/` + id,
      {
        method: 'DELETE',
      }).then(res => {
        this.getData();
      })

  }
  edit(faq) {
    this.setState({ question: faq.question });
    this.setState({ answer: faq.answer });
    this.setState({ edit: true });
    this.setState({ editId: faq.id })
  }

  // createUI() {
  //   return this.state.values.map((el, i) =>

  //   )
  // }


  handleChange(i, event) {
    let values = [...this.state.values];
    values[i][event.target.id] = event.target.value;
    this.setState({ values });
  }

  addClick() {
    this.setState(prevState => ({ values: [...prevState.values, { question: '', response: '', }] }))
  }

  removeClick(i) {
    let values = [...this.state.values];
    values.splice(i, 1);
    this.setState({ values });
  }





  render() {
    if (this.state.noData) {
        return <p>No Data was returned!</p>;
      }
    return (

      <Grid className="CoomonT">
        {this.state.faq &&
          <div className="faqListC">
            
              <div className="faqList">

<TableContainer>
      <Table size="small" className="usrDetails">
        <TableHead>
          <TableRow>
            <TableCell>orderId</TableCell>
            {/* <TableCell >brokerInv19Id</TableCell> */}
            {/* <TableCell >buyOrSellIndicator</TableCell> */}
            <TableCell >clientBowId</TableCell>
            {/* <TableCell >clientInv19Id</TableCell> */}
            
            <TableCell >createTime</TableCell>
            <TableCell >symbol</TableCell>
            <TableCell >Total trade</TableCell>
            <TableCell >TOTAL VOLUME</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {this.state.faq.map(faqList => (
            <TableRow key={faqList.orderId}>
                <TableCell>{faqList.orderId} </TableCell>
              
              {/* <TableCell>{faqList.brokerInv19Id}</TableCell> */}
              {/* <TableCell >{faqList.buyOrSellIndicator}</TableCell> */}
              <TableCell >{faqList.clientBowId}</TableCell>
              {/* <TableCell>{faqList.ClientInv19Id}</TableCell> */}
              
              <TableCell>
              <Moment interval={30000} format="ll"> 
                    {faqList.createTime}
                </Moment>
              </TableCell>
              <TableCell>{faqList.symbol}</TableCell>
              <TableCell>{faqList.count}</TableCell>
              <TableCell>{faqList.amount} </TableCell>
            </TableRow>
         ))}
        </TableBody>
      </Table>
    </TableContainer>

              </div>
            

          </div>}



      </Grid>






    )
  }
}
export default TradeUser;
